<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="10">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKeyWord"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              class="ml-2"
              size="sm"
              @click="$emit('openChoiceProduct')"
              variant="outline-success"
              >{{ $l("btn_choose_product") || "选择产品" }}</b-button
            >
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-danger"
              @click="$emit('batchDel')"
              >{{ $l("btn_choose_del") || "批量删除" }}</b-button
            >
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-info"
              @click="$emit('buildRecommend')"
              >{{ $l("btn_recommend") || "生成推荐" }}</b-button
            >
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-primary"
              @click="$emit('buildQuotation')"
              >{{ $l("btn_quotation") || "生成报价" }}</b-button
            >
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="'推荐状态'">
              <el-checkbox-group v-model="form.recommendStatusList">
                <el-checkbox label="N">{{ "未推荐" }}</el-checkbox>
                <el-checkbox label="T">{{ "已推荐" }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'选品状态'">
              <el-checkbox-group v-model="form.choiceStatusList">
                <el-checkbox label="N">{{ "未反馈" }}</el-checkbox>
                <el-checkbox label="C">{{ "客人选中" }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="'报价状态'">
              <el-checkbox-group v-model="form.quotationStatusList">
                <el-checkbox label="N">{{ "未报价" }}</el-checkbox>
                <el-checkbox label="Q">{{ "已报价" }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  searchKey: "",
  recommendStatusList: ["N", "T"],
  choiceStatusList: ["N", "C"],
  quotationStatusList: ["N", "Q"],
};

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
};
</script>
